import { motion } from "motion/react"
import ProductCard from "./ProductCard"

interface Product {
  key: string
  name: string
  baseline: string
  description: string
  features: string[]
  url: string
}

interface ProductsProps {
  products: Product[]
}

export default function Products({ products }: ProductsProps) {
  return (
    <section id="products" className="py-24 bg-[#06060f] relative scroll-mt-16">
      <div className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage: "radial-gradient(circle, rgba(6,182,212,0.5) 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Nos{" "}
            <span className="bg-gradient-to-r from-cyan-400 to-violet-400 bg-clip-text text-transparent">
              produits
            </span>
          </h2>
          <p className="max-w-xl mx-auto text-slate-400">
            Des logiciels développés en interne pour résoudre des besoins métier réels
          </p>
          <div className="mt-4 w-20 h-px bg-gradient-to-r from-cyan-500 to-violet-500 mx-auto" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {products.map((product, index) => (
            <ProductCard
              key={product.key}
              productKey={product.key}
              name={product.name}
              baseline={product.baseline}
              description={product.description}
              features={product.features}
              url={product.url}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  )
}
